export const SHOULD_BLOCK_EDITOR_X_SIGNUP_FT =
  'specs.ident.ShouldBlockEditorXSignup';
export const PETRI_SCOPE = 'users';
export const RENDER_APP_PATH = 'loginApp';
